import {useEffect} from 'react';

import animationDurations from '../consts/animation/animationDurations';
import {getIsMotionReduced} from '../utils/motionUtils';

const {MAX_FRAME_MS} = animationDurations;

/**
 * One requestAnimationFrame loop for an animation that writes to the DOM directly, outside React state.
 * `createFrame` runs once on mount - its closure holds the DOM lookups and the loop's state - and returns
 * the per-frame writer, called with the seconds since the previous frame, clamped to MAX_FRAME_MS.
 *
 * Under prefers-reduced-motion `createFrame` still runs, so it can set the resting pose, but no frame is
 * ever drawn.
 */
const useAnimationLoop = (createFrame) => {
    useEffect(() => {
        const onFrame = createFrame();

        if (!onFrame || getIsMotionReduced()) return undefined;

        let previousTime = 0;
        let frameId = requestAnimationFrame(function renderFrame(time) {
            frameId = requestAnimationFrame(renderFrame);

            const sinceLastFrameS = (time - previousTime) / 1000;

            previousTime = time;
            onFrame(Math.min(sinceLastFrameS, MAX_FRAME_MS / 1000));
        });

        return () => cancelAnimationFrame(frameId);
    }, []);
};

export default useAnimationLoop;
